module.exports = __webpack_public_path__ + "static/media/menu-icon.6682cf4c.svg";